export const urlTemplate = (url, values = {}) =>
  Object.entries(values).reduce(
    (accUrl, [key, val]) => accUrl.replace(`{${key}}`, val),
    url,
  );
